import { render } from "./menuItemBasket.vue?vue&type=template&id=097e8fdb&scoped=true"
import script from "./menuItemBasket.vue?vue&type=script&lang=js"
export * from "./menuItemBasket.vue?vue&type=script&lang=js"

import "./menuItemBasket.vue?vue&type=style&index=0&id=097e8fdb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-097e8fdb"]])

export default __exports__